import Vue from 'vue';

import './element-ui';
import { install as installMenuLayout } from './common/menuLayout';
import { install as installMainLayout } from './common/mainLayout';

installMenuLayout(Vue);
installMainLayout(Vue);
